import React from 'react'

import LeftControls from './LeftControls'
import RightControls from './RightControls'
import { Container } from './styles'

const TopControlBar = () => {
    return (
        <Container>
            <LeftControls />
            <RightControls />
        </Container>
    )
}

TopControlBar.propTypes = {}

export default TopControlBar
